import { IconWithText } from 'common/icon/icon-with-text.js';
import { IconNameV1 } from 'common/icon/iconV1.js';

export interface ITabHeaderProps {
  icon: IconNameV1;
  headerName: string;
  headerDate: string;
  children: JSX.Element;
}

export const TabHeaderLgTitle = ({ icon, headerName, headerDate, children }: ITabHeaderProps) => {
  return (
    <>
      <IconWithText icon={icon} classes="IconWithText--vCenter u-pR-sm u-mB-xs u-mR-sm">
        <h4 className="u-mT-0 u-mB-0">{headerName}</h4>
        <h4 className="u-mT-0 u-mB-0 u-textRegular">{headerDate}</h4>
      </IconWithText>
      {children}
    </>
  );
};
